import { AllSameKeyValuesEnforcer, createSameKeyValues } from '../helpers/helpers'
import { SocialLink, EntityBase, entityProps, addPublicEntityKeys, addExcludedEntityTemplateKeys } from './entity.shared.data';
import { Ranking } from '../store/events.data';
export { SocialLink }
export const nonSpecificPerformerName = 'anyone';
export type MediaTermState = 'Off' | 'Accepted' | 'Not Accepted'
export const mediaTerms: MediaTermState[] = ['Off', 'Not Accepted', 'Accepted']
export const mediaTermColors = { Off: 'gray', 'Not Accepted': 'yellow', Accepted: 'green' }

const PerformerTabs = [ "details", "sessions", "quickNotes", "infoForPerformer", "configBrief", "preview", "contact", "tasks", "assets", "schedule" ] as const
export const performerTabs = createSameKeyValues(PerformerTabs)

export interface Performer extends EntityBase {
  bio?: string
  briefed?: boolean
  contact?: string // an email for a WFWorker
  email?: string
  line1?: string
  line2?: string
  phone?: string
  photoUrl?: string
  fullPhotoUrl?: string
  showEditProfileLinkInPerformerBrief?: boolean // when active, of course.  This needs to be moved here because this option can be toggled to true before the performer brief shareable is created...
  showAssetsLinkInBrief?: boolean
  photoHidden?: boolean // this is a data hack to get down to the timeline item level in the simplest way possible.
}

export const makeDefaultEntityTypes = (): Ranking[] => [
  { name: 'Standard', id: 'default', rank: 1, cannotDelete: true }
]

const performerOnlyProps: AllSameKeyValuesEnforcer<Omit<Performer, keyof EntityBase>> = { 
  bio: 'bio', briefed: 'briefed', contact: 'contact', email: 'email', line1: 'line1', line2: 'line2',
  phone: 'phone', photoUrl: 'photoUrl', photoHidden: 'photoHidden', showAssetsLinkInBrief: 'showAssetsLinkInBrief', 
  fullPhotoUrl: 'fullPhotoUrl', showEditProfileLinkInPerformerBrief: 'showEditProfileLinkInPerformerBrief' 
}
export const performerProps: AllSameKeyValuesEnforcer<Performer> = { ...entityProps, ...performerOnlyProps }

export const publicPerformerKeys: Set<keyof Performer> = new Set(['bio', 'line1', 'line2', 'photoUrl', 'contact', 'fullPhotoUrl',  'showEditProfileLinkInPerformerBrief'])
addPublicEntityKeys(publicPerformerKeys)

export const excludedTemplatePerformerProps: Set<keyof Performer> = new Set(['briefed', 'showEditProfileLinkInPerformerBrief', 'photoHidden', 'showAssetsLinkInBrief'])
addExcludedEntityTemplateKeys(excludedTemplatePerformerProps)